"use strict";
((global) => {
  const { $, $$, show, hide, debounce, getCsrfToken } = Utils;
  const state = State.wizard;
  const AUTO_ADVANCE_MS = 400;
  const init = () => {
    Bottomsheet.init?.();
    const wizard = Wizard.init();
    Kozijnen.init();
    if (globalThis.CvEditor) {
      globalThis.cvEditorInstance = new CvEditor("cv-editor-overlay");
      const overlay = document.getElementById("cv-editor-overlay");
      overlay?.addEventListener("cv-save", (e) => {
        const { points, dimensions } = e.detail;
        console.log("[App] CV Dimensions saved:", dimensions);
        state.set("cv_analysis", { points, dimensions });
        const widthInput = document.getElementById("wizard-width-3a");
        const heightInput = document.getElementById("wizard-height-3a");
        if (widthInput && heightInput) {
          widthInput.value = Math.round(dimensions.width);
          heightInput.value = Math.round(dimensions.height);
          Kozijnen.storeCurrentDimensions();
        }
      });
    }
    setupOptionDelegation();
    initPostcodeStep();
    bindStep3aNavigation();
    bindStep3Navigation();
    bindDeurenSteps();
    bindHoutrotSteps();
    bindMediaStep();
    bindContactStep();
    bindRALMoreColors();
    globalThis.lucide?.createIcons();
    wizard.showStep("0");
  };
  const setupOptionDelegation = () => {
    const form = $("#offerte-wizard");
    if (!form) return;
    let lastInput = null;
    let lastTime = 0;
    const handleSelection = (key, val, noNext) => {
      if (key === "service") {
        state.resetServiceData(val);
      }
      state.set(key, val);
      if (!noNext) setTimeout(() => Wizard.navigateNext(), AUTO_ADVANCE_MS);
    };
    form.addEventListener("click", (e) => {
      const label = e.target.closest("label.wizard-option");
      if (!label) return;
      const input = label.querySelector('input[type="radio"], input[type="checkbox"]');
      if (!input) return;
      const now = Date.now();
      if (input === lastInput && now - lastTime < 100) return;
      lastInput = input;
      lastTime = now;
      const noNext = label.dataset.noAutoAdvance !== void 0;
      const inputName = input.name;
      if (!inputName) return;
      let stateKey = inputName.replaceAll("wizard-", "");
      stateKey = stateKey.replaceAll(/-([a-z])/g, (_, c) => c.toUpperCase());
      requestAnimationFrame(() => {
        if (input.checked) handleSelection(stateKey, input.value, noNext);
      });
    });
  };
  const initPostcodeStep = () => {
    const containerId = "wizard-step-0";
    const container = $(`#${containerId}`);
    if (!container) return;
    const postcodeController = new PostcodeStepController(containerId);
    postcodeController?.init?.();
    container.addEventListener("wizard:step-complete", (e) => {
      const { postcode } = e.detail.data;
      state.set("userPostcode", postcode);
      state.set("postcode", postcode);
      Wizard.navigateNext();
    });
  };
  const bindRALMoreColors = () => {
    const btn = $("#ral-more-colors-btn");
    if (!btn) return;
    const onSelect = (code) => {
      RALColors.selectColor(code);
      setTimeout(() => Wizard.navigateNext(), AUTO_ADVANCE_MS);
    };
    btn.addEventListener("click", () => {
      RALColors.openPicker(onSelect);
    });
  };
  const bindStep3aNavigation = () => {
    const nextBtn = $("#wizard-3a-next");
    const editDimsBtn = $("#wizard-edit-dims-btn");
    nextBtn?.addEventListener("click", () => {
      if (!Kozijnen.validateStep3a()) return;
      Kozijnen.storeCurrentDimensions();
      const type = state.get("currentType");
      if (type === "deur") {
        Kozijnen.addElement({
          width: state.get("currentWidth"),
          height: state.get("currentHeight"),
          type: "deur",
          vakken: 1
        });
        Wizard.showStep("3");
        return;
      }
      Wizard.navigateNext();
    });
    editDimsBtn?.addEventListener("click", () => {
      Wizard.showStep("3a", { skipHistory: true });
    });
  };
  const bindStep3Navigation = () => {
    $$('input[name="wizard-vakken"]').forEach((input) => {
      input.addEventListener("change", () => {
        state.set("currentVakken", Number.parseInt(input.value, 10));
      });
    });
  };
  const bindDeurenSteps = () => {
    $("#wizard-deuren-next")?.addEventListener("click", () => {
      Wizard.navigateNext();
    });
  };
  const bindHoutrotSteps = () => {
    const updateHoutrotEstimate = () => {
      const tiers = [1, 2, 3];
      let totalCost = 0;
      let totalSpots = 0;
      const prices = { 1: 95, 2: 185, 3: 295 };
      tiers.forEach((t) => {
        const count = state.get(`rot-tier-${t}`) || 0;
        totalSpots += count;
        totalCost += count * prices[t];
      });
      const isComplex = totalSpots > 10 || (state.get("rot-tier-3") || 0) > 5;
      const complexMsg = $("#rot-complex-msg");
      const estimateCard = $("#wizard-rot-estimate-card");
      const estimateText = $("#wizard-rot-estimate");
      if (isComplex) {
        if (complexMsg) show(complexMsg);
        if (estimateCard) hide(estimateCard);
      } else {
        if (complexMsg) hide(complexMsg);
        if (estimateCard) show(estimateCard);
        if (estimateText) estimateText.textContent = `\u20AC${totalCost}`;
      }
    };
    $$(".rot-qty-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const tier = btn.dataset.tier;
        const action = btn.dataset.action;
        const key = `rot-tier-${tier}`;
        let current = state.get(key) || 0;
        if (action === "plus") current++;
        else if (action === "minus") current = Math.max(0, current - 1);
        state.set(key, current);
        const span = $(`#rot-qty-${tier}`);
        if (span) span.textContent = current;
        updateHoutrotEstimate();
      });
    });
    const nextBtns = [$("#wizard-rot-to-contact"), $("#wizard-rot-complex-btn")];
    nextBtns.forEach((btn) => {
      btn?.addEventListener("click", () => Wizard.navigateNext());
    });
  };
  const bindMediaStep = () => {
    const uploadArea = $("#media-upload-area");
    const nextBtn = $("#media-next-btn");
    const clearBtn = $("#media-clear-all");
    const inputs = [
      $("#media-camera-input"),
      $("#media-file-input"),
      $("#media-file-input-desktop")
    ];
    inputs.forEach((input) => {
      input?.addEventListener("change", (e) => {
        handleMediaFiles(e.target.files);
        e.target.value = "";
      });
    });
    if (uploadArea) {
      uploadArea.addEventListener("dragover", (e) => {
        e.preventDefault();
        uploadArea.classList.add("border-[#D40032]", "bg-red-50");
      });
      uploadArea.addEventListener("dragleave", () => {
        uploadArea.classList.remove("border-[#D40032]", "bg-red-50");
      });
      uploadArea.addEventListener("drop", (e) => {
        e.preventDefault();
        uploadArea.classList.remove("border-[#D40032]", "bg-red-50");
        handleMediaFiles(e.dataTransfer.files);
      });
    }
    nextBtn?.addEventListener("click", () => Wizard.navigateNext());
    clearBtn?.addEventListener("click", () => {
      state.set("files", []);
      renderMediaPreview();
    });
  };
  const handleMediaFiles = (files) => {
    if (!files?.length) return;
    const currentFiles = state.get("files") || [];
    const newFiles = Array.from(files).slice(0, 5 - currentFiles.length);
    state.set("files", [...currentFiles, ...newFiles]);
    renderMediaPreview();
  };
  const activeBlobUrls = /* @__PURE__ */ new Set();
  const revokeAllBlobUrls = () => {
    activeBlobUrls.forEach((url) => URL.revokeObjectURL(url));
    activeBlobUrls.clear();
  };
  const renderMediaPreview = () => {
    const container = $("#media-preview-container");
    const preview = $("#media-preview-scroll");
    const countEl = $("#preview-count");
    const files = state.get("files") || [];
    if (!preview) return;
    revokeAllBlobUrls();
    if (countEl) countEl.textContent = files.length;
    if (files.length === 0) {
      preview.innerHTML = "";
      if (container) hide(container);
      return;
    }
    if (container) show(container);
    preview.innerHTML = files.map((file, i) => {
      const url = URL.createObjectURL(file);
      activeBlobUrls.add(url);
      return `
            <div class="relative w-20 h-20 sm:w-24 sm:h-24 bg-neutral-100 rounded-lg overflow-hidden shrink-0 snap-start border border-neutral-200 cursor-pointer media-thumb" data-index="${i}" data-url="${url}">
                <img src="${url}" class="w-full h-full object-cover pointer-events-none" alt="${file.name}" />
                <button type="button" class="media-remove absolute top-1 right-1 w-5 h-5 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-[#D40032] transition-colors z-10" data-index="${i}">
                    <i data-lucide="x" class="w-3 h-3"></i>
                </button>
            </div>
        `;
    }).join("");
    preview.querySelectorAll(".media-remove").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const files2 = state.get("files") || [];
        files2.splice(Number.parseInt(btn.dataset.index, 10), 1);
        state.set("files", [...files2]);
        renderMediaPreview();
      });
    });
    preview.querySelectorAll(".media-thumb").forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        if (e.target.closest(".media-remove")) return;
        openLightbox(thumb.dataset.url);
      });
    });
    globalThis.lucide?.createIcons();
  };
  const openLightbox = (url) => {
    const lightbox = $("#media-lightbox");
    const img = $("#media-lightbox-img");
    const closeBtn = $("#media-lightbox-close");
    const wizardContainer = $("#offerte-wizard");
    if (!lightbox || !img) return;
    img.src = url;
    lightbox.classList.remove("hidden");
    lightbox.classList.add("flex");
    if (wizardContainer) wizardContainer.inert = true;
    closeBtn?.focus();
    const closeLightbox = () => {
      lightbox.classList.add("hidden");
      lightbox.classList.remove("flex");
      if (wizardContainer) wizardContainer.inert = false;
    };
    closeBtn?.addEventListener("click", closeLightbox, { once: true });
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    }, { once: true });
    const escHandler = (e) => {
      if (e.key === "Escape") {
        closeLightbox();
        document.removeEventListener("keydown", escHandler);
      }
    };
    document.addEventListener("keydown", escHandler);
  };
  const bindContactStep = () => {
    const form = $("#offerte-wizard");
    const summaryCard = $("#wizard-summary-card");
    const summaryText = $("#wizard-summary-text");
    const summaryEstimate = $("#wizard-summary-estimate");
    const service = state.get("service");
    if (service === "kozijnen" && summaryCard) {
      const elements = state.get("elements") || [];
      const estimate = state.get("estimate");
      if (elements.length > 0) {
        show(summaryCard);
        summaryText.textContent = `${elements.length} kozijn(en) geconfigureerd`;
        if (estimate) {
          if (estimate.low && estimate.high) {
            summaryEstimate.textContent = `Indicatie: \u20AC${estimate.low} \u2013 \u20AC${estimate.high}`;
          } else if (estimate.low) {
            summaryEstimate.textContent = `Indicatie: \u20AC${estimate.low}`;
          }
        }
      } else {
        hide(summaryCard);
      }
    } else if (summaryCard) {
      hide(summaryCard);
    }
    ["name", "email", "phone", "address", "postcode", "city", "message"].forEach((field) => {
      const input = $(`#wizard-${field}`);
      input?.addEventListener("input", debounce(() => {
        state.set(field, input.value);
        Validation.clearError(input);
      }, 50));
    });
    form?.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (!validateContactForm()) return;
      await submitForm();
    });
  };
  const validateContactForm = () => {
    const { rules, validateForm, showError } = Validation;
    const schema = {
      name: [rules.required("Vul je naam in"), rules.minLength(2)()],
      email: [rules.required("Vul je e-mailadres in"), rules.email()],
      phone: [rules.required("Vul je telefoonnummer in"), rules.phone()]
    };
    const values = {
      name: state.get("name"),
      email: state.get("email"),
      phone: state.get("phone")
    };
    const result = validateForm(schema, values);
    if (!result.valid) {
      Object.entries(result.errors).forEach(([field, errors]) => {
        const input = $(`#wizard-${field}`);
        showError(input, errors[0]);
      });
      const firstField = Object.keys(result.errors)[0];
      $(`#wizard-${firstField}`)?.focus();
      return false;
    }
    return true;
  };
  const submitForm = async () => {
    const submitBtn = $("#wizard-submit");
    const originalText = submitBtn?.textContent;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Verzenden...";
    }
    syncContactFields();
    try {
      const formData = buildFormData();
      const csrfToken = getCsrfToken();
      const response = await fetch("/offerte/submit", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          ...csrfToken && { "X-CSRF-Token": csrfToken }
        },
        body: formData
      });
      if (!response.ok) throw new Error("Submission failed");
      const data = await response.json();

      globalThis.location.href = data.redirect || "/bedankt";
    } catch (err) {
      console.error("Form submission error:", err);
      Validation.showInlineMessage(
        submitBtn?.parentElement,
        "Er ging iets mis. Probeer het opnieuw."
      );
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }
  };
  const buildFormData = () => {
    const formData = new FormData();
    const data = state.get();
    Object.entries(data).forEach(([key, value]) => {
      if (value != null && typeof value !== "object") {
        formData.append(key, value);
      }
    });
    const els = data.elements || [];
    formData.append("elements_json", JSON.stringify(els));
    const est = data.estimate;
    if (est) {
      if (est.low) formData.append("estimate_low", est.low);
      if (est.high) formData.append("estimate_high", est.high);
      if (data.service === "kozijnen") {
        formData.append("estimate_summary", `${els.length} kozijn(en) geconfigureerd`);
      }
    }
    appendServiceSpecificData(formData, data);
    if (data.cv_analysis) formData.append("cv_analysis_json", JSON.stringify(data.cv_analysis));
    const files = data.files || [];
    files.forEach((file) => formData.append("media", file));
    // Bot protection fields
    const formTimeInput = document.querySelector('#offerte-wizard input[name="_form_time"]');
    if (formTimeInput?.value) formData.append("_form_time", formTimeInput.value);
    formData.append("website", ""); // honeypot — must be empty
    return formData;
  };
  const appendServiceSpecificData = (formData, data) => {
    if (data.service === "houtrot") {
      const t = [data["rot-tier-1"] || 0, data["rot-tier-2"] || 0, data["rot-tier-3"] || 0];
      formData.append("rotTier1", t[0]);
      formData.append("rotTier2", t[1]);
      formData.append("rotTier3", t[2]);
      const total = t[0] + t[1] + t[2];
      if (total > 10 || t[2] > 5) {
        formData.append("estimate_summary", `${total} houtrot plek(ken) - complexe situatie, inspectie nodig`);
      } else if (total > 0) {
        formData.append("estimate_summary", `${total} houtrot plek(ken)`);
        formData.append("estimate_low", t[0] * 95 + t[1] * 185 + t[2] * 295);
      }
    } else if (data.service === "deuren") {
      formData.append("estimate_summary", `Deur aanvraag - ${data.deurAfwerking || "geen afwerking"}, ${data.deurMontage || "geen montage"}`);
    }
  };
  const syncContactFields = () => {
    ["name", "email", "phone", "address", "message"].forEach((field) => {
      const input = $(`#wizard-${field}`);
      if (input?.value && !state.get(field)) {
        state.set(field, input.value);
      }
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(globalThis);
